module.exports = __webpack_public_path__ + "static/stripe-3ef70f64f2d352d760c771c4829c2849.png";